import type { Theme } from '@emotion/react';
import { css  } from '@emotion/react';

import { breakpoint } from '@twistopayments/design-system/styles';


export const container = (
  theme: Theme,
  iconBackgroundColor: string,
  stepperBackgroundColor: string,
  iconRingColor?: string,
) => css`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  background-color: ${stepperBackgroundColor};
  border-radius: ${theme.borderRadius.circle};
  overflow: hidden;
  width: ${theme.spacing[32]};
  height: ${theme.spacing[32]};
  box-shadow: ${iconRingColor
    ? `0 0 0 2px ${iconRingColor}`
    : `0 0 0 4px ${stepperBackgroundColor}`};

  ${breakpoint.up('sm')} {
    width: ${theme.spacing[40]};
    height: ${theme.spacing[40]};
    box-shadow: ${iconRingColor
      ? `0 0 0 2px ${iconRingColor}`
      : `0 0 0 5px ${stepperBackgroundColor}`};
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background: ${iconBackgroundColor};
  }
`;

export const text = (textColor: string) => css`
  color: ${textColor};
  font-size: 14px;
  position: relative;

  ${breakpoint.up('sm')} {
    font-size: 16px;
  }
`;

export const customIcon = (theme: Theme) => css`
  width: ${theme.spacing[20]};
  height: ${theme.spacing[20]};
  position: relative;

  ${breakpoint.up('sm')} {
    width: ${theme.spacing[24]};
    height: ${theme.spacing[24]};
  }
`;
